import {ISolicitacaoTipoForm} from "@models/solicitacoes/solicitacoes.ts";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import React from "react";
import {decodeTipoPrimitivo, ISolicitacaoTipoFormNovoDto, tipoPrimitivo} from "@models/solicitacoes/dto.ts";
import {Delete} from "@mui/icons-material";

interface IFormProps {
    form: ISolicitacaoTipoForm
}


export const ReadForm: React.FC<IFormProps> = ({form}) => {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <Typography>Nome</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography>Tipo</Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>
                        <Typography>{form.nome}</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography>{decodeTipoPrimitivo(form.tipoPrimitivo)} {form.obrigatorio &&
                            <Typography color={'danger'}>*</Typography>}</Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}


interface NewFormProps {
    id: number
    form: ISolicitacaoTipoFormNovoDto
    onChange: (form: ISolicitacaoTipoFormNovoDto) => void,
    remove: () => void
    mount?: boolean,
    hasError?: boolean
}

export const NewForm: React.FC<NewFormProps> = ({form, onChange, remove, mount, hasError}) => {
    return (mount && <Grid
            width={'100%'}
            maxWidth={'100%'}
            container
            sx={{padding: 1}}
            direction={'row'}
            elevation={1}
            mb={1}
            component={Paper}>
            <Grid size={12}>
                <Grid container sx={{justifyContent: 'space-between'}}>
                    <div/>
                    <IconButton onClick={() => {
                        remove()
                    }} color={'error'}>
                        <Typography sx={{mr: 1, ml: 1}}>Remover campo</Typography>
                        <Delete color={'error'}/>
                    </IconButton>
                </Grid>
            </Grid>
            <Grid size={12}>
                <TextField size={'small'}
                           variant={'standard'}
                           fullWidth label={'Nome do campo'}
                           value={form.nome}
                           error={form.nome.length < 3 || hasError}
                           aria-errormessage={'Campo deve ter mais de 3 caracteres'}
                           onChange={(e) => {
                               onChange({
                                   ...form,
                                   nome: e.target.value
                               })
                           }} placeholder={'Nome do campo'}/>
            </Grid>
            <Grid size={12}>
                <TextField fullWidth
                           label={'Descrição do campo'}
                           size={'small'}
                           variant={'standard'}
                           value={form.descricao}
                           onChange={(e) => {
                               onChange({
                                   ...form,
                                   descricao: e.target.value
                               })
                           }} placeholder={'Descricao do campo'}/>
            </Grid>
            <Grid>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth variant="filled">
                    <InputLabel>Tipo do campo</InputLabel>
                    <Select
                        size={'small'} variant={'filled'}
                        label={'Tipo do campo'}
                        value={form.tipoPrimitivo}
                        onChange={(e) => {
                            onChange({
                                ...form,
                                tipoPrimitivo: e.target.value as tipoPrimitivo
                            })
                        }}>
                        <MenuItem value={'String'}>Texto</MenuItem>
                        <MenuItem value={'Number'}>Numero</MenuItem>
                        <MenuItem value={'Bool'}>Logica (Verdadeiro/falso)</MenuItem>
                        <MenuItem value={'Date'}>Data</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControlLabel onChange={(_e, v) => {
                    onChange({
                        ...form,
                        obrigatorio: v
                    })
                }} control={<Checkbox checked={form.obrigatorio ?? false}/>} label="Campo obrigatorio"/>
            </Grid>
        </Grid>
    )
}